import { forwardRef } from 'react';

import clsx from 'clsx';

import ImageListUI from '@gogame/ui/ImageList';
import { makeStyles } from '@gogame/ui/styles';

const useStyles = makeStyles(() => ({
  root: {
    transform: 'translateZ(0)',
  },
}));

export const ImageList = forwardRef(
  ({ children, className, ...props }, ref) => {
    const classes = useStyles();

    return (
      <ImageListUI
        {...props}
        className={clsx(classes.root, className)}
        ref={ref}
      >
        {children}
      </ImageListUI>
    );
  }
);
